// extracted by mini-css-extract-plugin
export var bodyRow = "_fe-d";
export var cardColumns = "_fe-e";
export var ellipsesOverflow = "_fe-2";
export var flatBottomCorners = "_fe-3";
export var flatTopCorners = "_fe-4";
export var headerActionsDropdown = "_fe-f";
export var headerBottomRow = "_fe-c";
export var headerTopRow = "_fe-b";
export var orderDetailsWrapper = "_fe-0";
export var orderInfoContainer = "_fe-1";
export var productDetails = "_fe-9";
export var productImage = "_fe-5";
export var responsiveTable = "_fe-8";
export var shipmentContainer = "_fe-a";
export var tableBottomLeft = "_fe-6";
export var tableBottomRight = "_fe-7";
export var trackingLink = "_fe-g";